import React from 'react';
import {Table} from '..';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'imei',
    numeric: false,
    disabledPadding: true,
    label: 'IMEI',
  },
  {
    id: 'siteCode',
    numeric: false,
    disabledPadding: false,
    label: 'Site code',
  },
  {
    id: 'siteNo',
    numeric: false,
    disabledPadding: false,
    label: 'Site no',
  },
  {
    id: 'floor',
    numeric: false,
    disabledPadding: false,
    label: 'Floor',
  },
  {
    id: 'valid',
    numeric: false,
    disabledPadding: false,
    label: 'Valid',
  },
  {
    id: 'status',
    numeric: false,
    disabledPadding: false,
    label: 'Status',
  },
  {
    id: 'timestamp',
    numeric: false,
    disabledPadding: true,
    label: 'Time',
  },
];

const DATA_CELLS = [
  'imei',
  'siteCode',
  'siteNo',
  'floor',
  'valid',
  'status',
  'timestamp',
];

const CheckinsTable = ({checkins, loading}) => {
  const tableOrder = useTableSort('asc', 'timestamp');

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={checkins}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      noToolbar
      {...tableOrder}
    />
  );
};

export default CheckinsTable;
